module.exports = __webpack_public_path__ + "img/logo.ff1fe3a6.png";